export * from "-!../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--6-0!../../node_modules/vue-style-loader/index.js!../../node_modules/css-loader/index.js??ref--6-2!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/lib/index.js??ref--6-3!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./UserManagement.vue?vue&type=style&index=0&id=236156d2&prod&lang=css&"


//////////////////
// WEBPACK FOOTER
// ./src/views/UserManagement.vue?vue&type=style&index=0&id=236156d2&prod&lang=css&
// module id = WA3/
// module chunks = 1